import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownloadOutlined, ExportOutlined } from "@ant-design/icons";
import { Avatar, Button, theme } from "antd";
import { observer } from "mobx-react";
import { trackAnalyticsEvent } from "../../../../../others/tracking.js";
import { COLOR_PRIMARY_SOFT_BG } from "../../../../../style/antdTheme.js";
import { formatAmount } from "../../../../../utils/formatAmount.js";
import { formatLocaleDate } from "../../../../../utils/formatLocaleDate.js";
import { __ } from "../../../../../utils/i18n.js";
const InvoiceRow = observer(({ invoice })=>{
    const { token } = theme.useToken();
    const { data } = invoice;
    const logoUrl = data.product.logoSquare?.downloadUrl;
    // Net/gross qualifier on the total — the VAT amount itself is not shown in this row.
    const amountLabel = formatAmount({
        amount: +data.total,
        currency: data.currency,
        taxTreatment: invoice.taxTreatment
    });
    const dateLabel = formatLocaleDate(data.createdAt);
    return /*#__PURE__*/ _jsxs("div", {
        className: "rc-account-v2-invoice-row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-invoice-row__logo",
                children: logoUrl ? /*#__PURE__*/ _jsx(Avatar, {
                    className: "rc-account-v2-invoice-row__logo-avatar",
                    shape: "square",
                    src: logoUrl,
                    size: 48
                }) : /*#__PURE__*/ _jsx(Avatar, {
                    className: "rc-account-v2-invoice-row__logo-avatar rc-account-v2-invoice-row__logo-avatar--monogram",
                    shape: "square",
                    size: 48,
                    style: {
                        background: COLOR_PRIMARY_SOFT_BG,
                        color: token.colorPrimary
                    },
                    children: data.product.name.charAt(0).toUpperCase()
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-invoice-row__info",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-invoice-row__name",
                        style: {
                            color: token.colorTextHeading
                        },
                        children: data.productPlan.name
                    }),
                    data.productPlan.description && /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-invoice-row__plan",
                        style: {
                            color: token.colorTextSecondary
                        },
                        children: data.productPlan.description
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-invoice-row__meta-inline",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                style: {
                                    color: token.colorTextSecondary
                                },
                                children: dateLabel
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                style: {
                                    color: token.colorTextTertiary
                                },
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "rc-account-v2-invoice-row__amount-inline",
                                style: {
                                    color: token.colorTextHeading
                                },
                                children: amountLabel
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-invoice-row__meta",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-invoice-row__meta-col",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "rc-account-v2-invoice-row__meta-label",
                                style: {
                                    color: token.colorTextSecondary
                                },
                                children: __("Invoice date")
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "rc-account-v2-invoice-row__date",
                                style: {
                                    color: token.colorText
                                },
                                children: dateLabel
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "rc-account-v2-invoice-row__meta-col",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "rc-account-v2-invoice-row__meta-label",
                                style: {
                                    color: token.colorTextSecondary
                                },
                                children: __("Total")
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "rc-account-v2-invoice-row__amount",
                                style: {
                                    color: token.colorTextHeading
                                },
                                children: amountLabel
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-invoice-row__actions",
                children: [
                    data.invoiceUrl && /*#__PURE__*/ _jsx(Button, {
                        icon: /*#__PURE__*/ _jsx(ExportOutlined, {}),
                        onClick: ()=>{
                            trackAnalyticsEvent("invoice_open", {
                                ga: {
                                    event_category: "account",
                                    event_label: "Invoice open",
                                    value: data.productPlan?.name
                                },
                                matomo: {
                                    category: "account",
                                    name: "Invoice open"
                                }
                            });
                            window.open(data.invoiceUrl, "_blank");
                        },
                        children: __("Open")
                    }),
                    data.invoiceUrlPdf && /*#__PURE__*/ _jsx(Button, {
                        icon: /*#__PURE__*/ _jsx(DownloadOutlined, {}),
                        onClick: ()=>{
                            trackAnalyticsEvent("invoice_download", {
                                ga: {
                                    event_category: "account",
                                    event_label: "Invoice download",
                                    value: data.productPlan?.name
                                },
                                matomo: {
                                    category: "account",
                                    name: "Invoice download"
                                }
                            });
                            window.open(data.invoiceUrlPdf, "_blank");
                        },
                        children: __("Download")
                    })
                ]
            })
        ]
    });
});
export { InvoiceRow };
